import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import { GlobalFeedbackService } from '../../services/global-feedback.service';

@Component({
  selector: 'app-global-feedback-banner',
  imports: [CommonModule],
  templateUrl: './global-feedback-banner.component.html',
  styleUrl: './global-feedback-banner.component.scss',
})
export class GlobalFeedbackBannerComponent {
  readonly feedback = inject(GlobalFeedbackService);

  dismiss(): void {
    this.feedback.clearError();
  }

  runAction(): void {
    this.feedback.runActiveAction();
  }
}
